import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MP',
  name: 'María P.',
  role: 'Docente de Química — Lima, Perú',
  text: '"Mis alumnos por fin entienden la diferencia entre enlace iónico y covalente. Antes yo misma perdía tiempo buscando cómo explicarlo sin que se durmieran. Ahora entro al aula con todo listo y ellos me hacen preguntas que nunca antes hacían."'
}, {
  initials: 'JM',
  name: 'Jorge M.',
  role: 'Profesor de Química — Buenos Aires, Argentina',
  text: '"Nunca más llegué a una clase sin saber cómo explicar la estequiometría o los tipos de reacciones. El material hace el trabajo pesado por mí. Mis alumnos de escuela técnica finalmente conectan la química con la industria de su región."'
}, {
  initials: 'SL',
  name: 'Sofía L.',
  role: 'Docente de bachillerato — Bogotá, Colombia',
  text: '"Las planificaciones me ahorran horas. No improviso nunca más frente a mis alumnos. Y lo mejor: cada ejemplo está pensado para Latinoamérica, no para Europa o Estados Unidos."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-night border-y border-night-border" data-id="element-289">
      <div className="max-w-7xl mx-auto px-4" data-id="element-290">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-291">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-night-card border border-gold/20 p-6 rounded-2xl relative" data-id="element-292">
              <div className="flex gap-1 text-gold mb-4" data-id="element-293">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-294" />)}
              </div>
              <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-295">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-296">
                <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold" data-id="element-297">
                  {t.initials}
                </div>
                <div data-id="element-298">
                  <div className="font-bold text-white text-sm" data-id="element-299">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-300">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}